import NavBar from "../components/NavBar";
import Home from "../components/Home";
import AboutMe from "../components/AboutMe";
import Skills from "../components/Skills";
import Projects from "../components/Projects";
import Contacts from "../components/Contacts";
import { additionalSkills } from "../additionalSkills";
import useFancybox from "../useFancybox";

export default function HomeP() {
  const [fancyboxRef] = useFancybox({});

  return (
    <main ref={fancyboxRef}>
      <NavBar />
      <Home />
      <AboutMe />
      <Skills />
      <div style={{ textAlign: "center" }}>
        <h1>Навыки</h1>
      </div>
      <div className="experience-wrapper">
        <div className="experience-content">
          {additionalSkills.map((obj) => (
            <a
              key={obj.id}
              style={{ color: "white", textDecoration: "none" }}
              target="_blank"
              href={obj.href}
            >
              <article className="experience-card">
                <div className="experience-round">
                  <img
                    className="experience__img"
                    width={75}
                    height={75}
                    src={obj.image}
                    fetchpriority="low"
                    loading="lazy"
                  />
                </div>
                <span>{obj.title}</span>
              </article>
            </a>
          ))}
        </div>
      </div>
      <Projects />
      <Contacts />
    </main>
  );
}
